var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvergreenTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53859 17.647L3.29595 13.4044C3.00306 13.1115 3.03684 12.6028 3.37139 12.2683C3.70595 11.9337 4.2146 11.8999 4.50749 12.1928L8.21981 15.9051L19.6608 4.46418C19.9953 4.12962 20.504 4.09585 20.7968 4.38874C21.0897 4.68164 21.056 5.19028 20.7214 5.52484L8.6747 17.5716C8.34014 17.9061 7.83149 17.9399 7.5386 17.647C7.5386 17.647 7.53859 17.647 7.53859 17.647Z",
    fill: "#0A544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvergreenTick);
export default __webpack_public_path__ + "static/media/evergreen-tick.57312ce754c30770dd71eafd7484c309.svg";
export { ForwardRef as ReactComponent };